import { Locale } from './config';

export const pathnames: Record<string, Record<Locale, string>> = {
  '/about': {
    en: '/about',
    es: '/sobre-nosotros',
    fr: '/a-propos',
    de: '/ueber-uns',
    ro: '/despre',
    pt: '/sobre',
    zh: '/about',
    hi: '/about',
    ar: '/about',
    bn: '/about',
    it: '/chi-siamo',
    ru: '/o-nas',
  },
  '/contact': {
    en: '/contact',
    es: '/contacto',
    fr: '/contact',
    de: '/kontakt',
    ro: '/contact',
    pt: '/contato',
    zh: '/contact',
    hi: '/contact',
    ar: '/contact',
    bn: '/contact',
    it: '/contatti',
    ru: '/kontakty',
  },
  '/faq': {
    en: '/faq',
    es: '/preguntas-frecuentes',
    fr: '/faq',
    de: '/faq',
    ro: '/intrebari-frecvente',
    pt: '/perguntas-frequentes',
    zh: '/faq',
    hi: '/faq',
    ar: '/faq',
    bn: '/faq',
    it: '/faq',
    ru: '/faq',
  },
  '/blog': {
    en: '/blog',
    es: '/blog',
    fr: '/blog',
    de: '/blog',
    ro: '/blog',
    pt: '/blog',
    zh: '/blog',
    hi: '/blog',
    ar: '/blog',
    bn: '/blog',
    it: '/blog',
    ru: '/blog',
  },
  '/author': {
    en: '/author',
    es: '/autor',
    fr: '/auteur',
    de: '/autor',
    ro: '/autor',
    pt: '/autor',
    zh: '/author',
    hi: '/author',
    ar: '/author',
    bn: '/author',
    it: '/autore',
    ru: '/avtor',
  },
  '/privacy': {
    en: '/privacy',
    es: '/privacidad',
    fr: '/confidentialite',
    de: '/datenschutz',
    ro: '/confidentialitate',
    pt: '/privacidade',
    zh: '/privacy',
    hi: '/privacy',
    ar: '/privacy',
    bn: '/privacy',
    it: '/privacy',
    ru: '/konfidentsialnost',
  },
  '/terms': {
    en: '/terms',
    es: '/terminos',
    fr: '/conditions',
    de: '/agb',
    ro: '/termeni',
    pt: '/termos',
    zh: '/terms',
    hi: '/terms',
    ar: '/terms',
    bn: '/terms',
    it: '/termini',
    ru: '/usloviya',
  },
  '/cookie-policy': {
    en: '/cookie-policy',
    es: '/politica-de-cookies',
    fr: '/politique-de-cookies',
    de: '/cookie-richtlinie',
    ro: '/politica-cookies',
    pt: '/politica-de-cookies',
    zh: '/cookie-policy',
    hi: '/cookie-policy',
    ar: '/cookie-policy',
    bn: '/cookie-policy',
    it: '/politica-dei-cookie',
    ru: '/politika-cookie',
  },
  '/cashback-terms': {
    en: '/cashback-terms',
    es: '/terminos-cashback',
    fr: '/conditions-cashback',
    de: '/cashback-bedingungen',
    ro: '/termeni-cashback',
    pt: '/termos-cashback',
    zh: '/cashback-terms',
    hi: '/cashback-terms',
    ar: '/cashback-terms',
    bn: '/cashback-terms',
    it: '/termini-cashback',
    ru: '/usloviya-keshbeka',
  },
  '/referral-terms': {
    en: '/referral-terms',
    es: '/terminos-de-referidos',
    fr: '/conditions-de-parrainage',
    de: '/empfehlungsbedingungen',
    ro: '/termeni-recomandari',
    pt: '/termos-de-indicacao',
    zh: '/referral-terms',
    hi: '/referral-terms',
    ar: '/referral-terms',
    bn: '/referral-terms',
    it: '/termini-referral',
    ru: '/usloviya-referalov',
  },
  '/return': {
    en: '/return',
    es: '/devoluciones',
    fr: '/retours',
    de: '/rueckgabe',
    ro: '/retururi',
    pt: '/devolucao',
    zh: '/return',
    hi: '/return',
    ar: '/return',
    bn: '/return',
    it: '/reso',
    ru: '/vozvrat',
  },
  '/cart': {
    en: '/cart',
    es: '/carrito',
    fr: '/panier',
    de: '/warenkorb',
    ro: '/cos',
    pt: '/carrinho',
    zh: '/cart',
    hi: '/cart',
    ar: '/cart',
    bn: '/cart',
    it: '/carrello',
    ru: '/korzina',
  },
  '/giftcards': {
    en: '/giftcards',
    es: '/tarjetas-regalo',
    fr: '/cartes-cadeaux',
    de: '/geschenkkarten',
    ro: '/carduri-cadou',
    pt: '/cartoes-presente',
    zh: '/giftcards',
    hi: '/giftcards',
    ar: '/giftcards',
    bn: '/giftcards',
    it: '/carte-regalo',
    ru: '/podarochnye-karty',
  },
  '/order': {
    en: '/order',
    es: '/pedido',
    fr: '/commande',
    de: '/bestellung',
    ro: '/comanda',
    pt: '/pedido',
    zh: '/order',
    hi: '/order',
    ar: '/order',
    bn: '/order',
    it: '/ordine',
    ru: '/zakaz',
  },
  "/pages": {
    "en": "/pages",
    "es": "/paginas",
    "fr": "/pages",
    "de": "/seiten",
    "ro": "/pagini",
    "pt": "/paginas",
    "zh": "/pages",
    "hi": "/pages",
    "ar": "/pages",
    "bn": "/pages",
    "it": "/pagine",
    "ru": "/stranitsy"
  },
  '/brands': {
    en: '/brands',
    es: '/marcas',
    fr: '/marques',
    de: '/marken',
    ro: '/branduri',
    pt: '/marcas',
    zh: '/brands',
    hi: '/brands',
    ar: '/brands',
    bn: '/brands',
    it: '/marchi',
    ru: '/brendy',
  },
  // IMPORTANT: sub-paths must come BEFORE '/account' so prefix matching
  // resolves the longer path first (e.g. /ro/cont/comenzi -> /account/orders, not /account/comenzi)
  '/account/profile': {
    en: '/account/profile',
    es: '/cuenta/perfil',
    fr: '/compte/profil',
    de: '/konto/profil',
    ro: '/cont/profil',
    pt: '/conta/perfil',
    zh: '/account/profile',
    hi: '/account/profile',
    ar: '/account/profile',
    bn: '/account/profile',
    it: '/account/profilo',
    ru: '/account/profile',
  },
  '/account/password': {
    en: '/account/password',
    es: '/cuenta/contrasena',
    fr: '/compte/mot-de-passe',
    de: '/konto/passwort',
    ro: '/cont/parola',
    pt: '/conta/senha',
    zh: '/account/password',
    hi: '/account/password',
    ar: '/account/password',
    bn: '/account/password',
    it: '/account/password',
    ru: '/account/password',
  },
  '/account/orders': {
    en: '/account/orders',
    es: '/cuenta/pedidos',
    fr: '/compte/commandes',
    de: '/konto/bestellungen',
    ro: '/cont/comenzi',
    pt: '/conta/pedidos',
    zh: '/account/orders',
    hi: '/account/orders',
    ar: '/account/orders',
    bn: '/account/orders',
    it: '/account/ordini',
    ru: '/account/orders',
  },
  '/account/verification': {
    en: '/account/verification',
    es: '/cuenta/verificacion',
    fr: '/compte/verification',
    de: '/konto/verifizierung',
    ro: '/cont/verificare',
    pt: '/conta/verificacao',
    zh: '/account/verification',
    hi: '/account/verification',
    ar: '/account/verification',
    bn: '/account/verification',
    it: '/account/verifica',
    ru: '/account/verification',
  },
  '/account/wishlist': {
    en: '/account/wishlist',
    es: '/cuenta/lista-de-deseos',
    fr: '/compte/liste-de-souhaits',
    de: '/konto/wunschliste',
    ro: '/cont/lista-de-dorinte',
    pt: '/conta/lista-de-desejos',
    zh: '/account/wishlist',
    hi: '/account/wishlist',
    ar: '/account/wishlist',
    bn: '/account/wishlist',
    it: '/account/lista-dei-desideri',
    ru: '/account/wishlist',
  },
  '/account': {
    en: '/account',
    es: '/cuenta',
    fr: '/compte',
    de: '/konto',
    ro: '/cont',
    pt: '/conta',
    zh: '/account',
    hi: '/account',
    ar: '/account',
    bn: '/account',
    it: '/account',
    ru: '/account',
  },
  '/login': {
    en: '/login',
    es: '/iniciar-sesion',
    fr: '/connexion',
    de: '/anmelden',
    ro: '/autentificare',
    pt: '/entrar',
    zh: '/login',
    hi: '/login',
    ar: '/login',
    bn: '/login',
    it: '/accedi',
    ru: '/login',
  },
  '/register': {
    en: '/register',
    es: '/registro',
    fr: '/inscription',
    de: '/registrieren',
    ro: '/inregistrare',
    pt: '/registrar',
    zh: '/register',
    hi: '/register',
    ar: '/register',
    bn: '/register',
    it: '/registrati',
    ru: '/register',
  },
  '/forgot-password': {
    en: '/forgot-password',
    es: '/recuperar-contrasena',
    fr: '/mot-de-passe-oublie',
    de: '/passwort-vergessen',
    ro: '/parola-uitata',
    pt: '/esqueci-senha',
    zh: '/forgot-password',
    hi: '/forgot-password',
    ar: '/forgot-password',
    bn: '/forgot-password',
    it: '/password-dimenticata',
    ru: '/forgot-password',
  },
  '/reset-password': {
    en: '/reset-password',
    es: '/restablecer-contrasena',
    fr: '/reinitialiser-mot-de-passe',
    de: '/passwort-zuruecksetzen',
    ro: '/reseteaza-parola',
    pt: '/redefinir-senha',
    zh: '/reset-password',
    hi: '/reset-password',
    ar: '/reset-password',
    bn: '/reset-password',
    it: '/reimposta-password',
    ru: '/reset-password',
  },
  '/confirm-email': {
    en: '/confirm-email',
    es: '/confirmar-email',
    fr: '/confirmer-email',
    de: '/email-bestaetigen',
    ro: '/confirma-email',
    pt: '/confirmar-email',
    zh: '/confirm-email',
    hi: '/confirm-email',
    ar: '/confirm-email',
    bn: '/confirm-email',
    it: '/conferma-email',
    ru: '/confirm-email',
  },
  // Same slug everywhere on purpose - these links are embedded in newsletter
  // emails (incl. external platforms) and must stay stable across locales.
  '/newsletter': {
    en: '/newsletter',
    es: '/newsletter',
    fr: '/newsletter',
    de: '/newsletter',
    ro: '/newsletter',
    pt: '/newsletter',
    zh: '/newsletter',
    hi: '/newsletter',
    ar: '/newsletter',
    bn: '/newsletter',
    it: '/newsletter',
    ru: '/newsletter',
  },
};

export function getLocalizedPath(canonicalPath: string, locale: Locale): string {
  const basePath = Object.keys(pathnames).find(p => canonicalPath.startsWith(p));
  if (!basePath) return canonicalPath;
  
  const localizedBase = pathnames[basePath][locale];
  const remainder = canonicalPath.slice(basePath.length);
  return localizedBase + remainder;
}

export function getCanonicalPath(localizedPath: string, locale: Locale): string {
  for (const [canonical, translations] of Object.entries(pathnames)) {
    const localizedBase = translations[locale];
    if (localizedPath === localizedBase || localizedPath.startsWith(localizedBase + '/')) {
      const remainder = localizedPath.slice(localizedBase.length);
      return canonical + remainder;
    }
  }
  return localizedPath;
}

export function getAllLocalizedPaths(canonicalPath: string): Record<Locale, string> {
  const basePath = Object.keys(pathnames).find(p => canonicalPath === p || canonicalPath.startsWith(p + '/'));
  if (!basePath) {
    return {
      en: canonicalPath,
      es: canonicalPath,
      fr: canonicalPath,
      de: canonicalPath,
      ro: canonicalPath,
      pt: canonicalPath,
      zh: canonicalPath,
      hi: canonicalPath,
      ar: canonicalPath,
      bn: canonicalPath,
      it: canonicalPath,
      ru: canonicalPath,
    };
  }
  
  const remainder = canonicalPath.slice(basePath.length);
  const result: Record<Locale, string> = {} as Record<Locale, string>;
  for (const [locale, localizedBase] of Object.entries(pathnames[basePath])) {
    result[locale as Locale] = localizedBase + remainder;
  }
  return result;
}
